import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

// Tabs
import ServiceTab from "./Tabs/Service";
import MessagesTab from "./Tabs/Messages";
import CustomerTab from "./Tabs/Customer";
// import SecurityTab from "./Tabs/Security";

  const tabContent = [
    {panel: "service", content: <ServiceTab />},
    {panel: "customer", content: <CustomerTab />},
    {panel: "messages", content: <MessagesTab />},
  ]

const ViewServiceTicket = () => {

  const tabs = [
    {label: "Service", icon: <ReceiptLongRoundedIcon fontSize="small" />},
    {label: "Customer", icon: <ContactPageOutlinedIcon fontSize="small" />},
    {label: "Messages", icon: <ForumOutlinedIcon fontSize="small" />},
  ];

  return (
    <ViewDetails title="Service Ticket" identifier="service_ticket_id" tabs={tabs} tabContent={tabContent} isProfile={false} url="service_tickets">

    </ViewDetails>
  )
};

export default ViewServiceTicket;